<div class="loader-container" *ngIf="loadingSequence">
  <div class="three-strings">
    <span></span>
    <span></span>
    <span></span>
  </div>
  <div class="processing-text">Processing...</div>
</div>





<div class="right-side p-5" >
  <h2>On Spot Registration</h2>


  <div class="section" >
<!-- <div class="mb-3">
  <h2 class="fw-semibold mb-2">Choose Registration Type</h2>

  <div class="btn-group">
    <button 
      class="btn"
      [ngClass]="isOtpFlow ? 'btn-primary' : 'btn-outline-primary'"
      (click)="isOtpFlow = true">
      With OTP
    </button>

    <button 
      class="btn"
      [ngClass]="!isOtpFlow ? 'btn-primary' : 'btn-outline-primary'"
      (click)="isOtpFlow = false">
      Without OTP
    </button>
  </div>
</div> -->
<div class="mb-3">

  <div class="d-flex align-items-center gap-3 flex-wrap">

    <!-- Heading -->
  <h2 class="fw-semibold mb-2">Choose Registration Type</h2>

    <!-- Buttons -->
<div class="btn-group shadow-sm">

  <!-- With OTP -->
  <button
    type="button"
    class="btn px-4 fw-semibold"
    [ngClass]="
      isOtpFlow
        ? 'btn-primary text-white'
        : 'btn-outline-primary'
    "

    (click)="changeRegistrationType(true)"

    [disabled]="isEditMode && !isOtpFlow"

    [attr.data-bs-toggle]="
      !isEditMode && !isOtpFlow
        ? 'modal'
        : null
    "

    [attr.data-bs-target]="
      !isEditMode && !isOtpFlow
        ? '#registrationTypeModal'
        : null
    "
  >
    With OTP
  </button>

  <!-- Without OTP -->
  <button
    type="button"
    class="btn px-4 fw-semibold"
    [ngClass]="
      !isOtpFlow
        ? 'btn-primary text-white'
        : 'btn-outline-primary'
    "

    (click)="changeRegistrationType(false)"

    [disabled]="isEditMode && isOtpFlow"

    [attr.data-bs-toggle]="
      !isEditMode && isOtpFlow
        ? 'modal'
        : null
    "

    [attr.data-bs-target]="
      !isEditMode && isOtpFlow
        ? '#registrationTypeModal'
        : null
    "
  >
    Without OTP
  </button>

</div>

  </div>

</div>

    <div class="orginfodiv" *ngIf="isOtpFlow">



      <form [formGroup]="form">
        <div class="row">
          <div class="col-md-12 mb-5 text-center">
           <h2>On the Spot registration with OTP verification</h2>
            
              <h3>( UDYAM Registered MSME are allowed to enroll )</h3>
           
          </div>

          <div class="col-md-3 mb-2">
            <label class="nowrap">Udyam Number <span class="text-danger">*</span></label>
            <input type="text" autocomplete="off" formControlName="udyamNumber" trimValue id="txtUdyam"
              class="form-control" maxlength="19" placeholder="Enter Udyam Number" [disabled]="!isUdyamAvailable"
              [readonly]="isEditMode || isVerified" [ngClass]="{ 'readonly-input': isEditMode }" />

            <div *ngIf="f['udyamNumber'].touched && f['udyamNumber'].invalid" class="alert alert-danger required">
              <div *ngIf="
                  f['udyamNumber'].errors && f['udyamNumber'].errors['required']
                ">
                Udyam Number Name is required
              </div>
              <div *ngIf="
                  f['udyamNumber'].errors && f['udyamNumber'].errors['pattern']
                ">
                Please enter a valid UDYAM registration number.
              </div>
            </div>
          </div>

          <div class="col-md-3 mb-2">
            <div class="mdc-text-field">
              <mat-label>Mobile number registered with Udyam
                <span class="text-danger">*</span></mat-label>
              <input id="txtmobileNo" type="text" matInput placeholder="Enter Mobile Number" class="form-control" (keypress)="numberOnly($event)"
                formControlName="mobileNo" required maxlength="10" minlength="10" [disabled]="!isUdyamAvailable"
                [readonly]="isEditMode || isVerified" [ngClass]="{ 'readonly-input': isEditMode }" />
              <!-- Disable input when in edit mode -->
              <div *ngIf="f['mobileNo'].touched && f['mobileNo'].invalid">
                <div *ngIf="
                    f['mobileNo'].errors && f['mobileNo'].errors['required']
                  " class="alert alert-danger required">
                  Mobile number is required
                </div>
                <div *ngIf="
                    f['mobileNo'].errors && f['mobileNo'].errors['pattern']
                  ">
                  Mobile number should be 10 digits only, first digit should be
                  non zero
                </div>
                <div class="alert alert-warning">
                  Please enter Mobile Number Registered with your Udyam
                  Registration. OTP will be sent to it.
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-1 mb-2">
            <button *ngIf="!isEditMode" class="btn btn-success mt-4"
              (click)="verifyUdyam(f['udyamNumber'].value, f['mobileNo'].value)" id="btnReset"
              [disabled]="!isUdyamAvailable || isVerified" title="Verify">
              Verify
              <i class="bi bi-check-circle text-white fs-6"></i>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 mb-2">
            <label class="nowrap">Enterprise Name<span class="text-danger">*</span></label>
            <input type="text" autocomplete="off" formControlName="enterpriseName" trimValue id="txtEnterpriseName"
              class="form-control" name="enterpriseName" placeholder="Enterprise Name" [readonly]="
                isEditMode || isVerified || (!isEditMode && !isVerified)
              " [ngClass]="{ 'readonly-input': isEditMode }" />

            <div *ngIf="f['enterpriseName'].touched && f['enterpriseName'].invalid" class="alert alert-danger required">
              <div *ngIf="
                  f['enterpriseName'].errors &&
                  f['enterpriseName'].errors['required']
                ">
                Enterprise Name is required
              </div>
              <div *ngIf="
                  f['enterpriseName'].errors &&
                  f['enterpriseName'].errors['minlength']
                ">
                Minimum length should be 3 characters
              </div>
              <!-- <div *ngIf="
                  f['enterpriseName'].errors &&
                  f['enterpriseName'].errors['pattern']
                ">
                Enterprise name must not start with number or "&#64;+-=&".
              </div> -->
            </div>
          </div>

          <div class="col-md-2 mb-2">
            <label class="nowrap">Email<span class="text-danger">*</span></label>
            <input type="text" autocomplete="off" formControlName="email" trimValue id="txtEmail" class="form-control"
              name="email" placeholder="Email" [readonly]="
                isEditMode || isVerified || (!isEditMode && !isVerified)
              " [ngClass]="{ 'readonly-input': isEditMode }" />

            <div *ngIf="f['email'].touched && f['email'].invalid" class="alert alert-danger required">
              <div *ngIf="f['email'].errors && f['email'].errors['required']">
                Email is required
              </div>

              <div *ngIf="f['email'].errors && f['email'].errors['pattern']">
                Enter proper email only
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- Conditionally hide buttons if in edit mode -->
          <div class="col-md-6 mb-2 mt-4">
            <button type="button" (click)="sendOTP()" [disabled]="!(isVerified || isEditMode) || isSendButtonDisabled"
              class="btn btn-success me-2">
              Send OTP
            </button>
            <!-- Edit Button -->

            <button type="button" (click)="resendOTP()" [disabled]="isResendButtonDisabled" class="btn btn-success">
              Resend OTP
              <span *ngIf="mobileOtpTimerRunning">{{ mobileOtpTimer }} seconds</span>
            </button>
          </div>


        </div>

        <div class="row">
          <div class="col-md-3 mb-2">
            <label class="nowrap">Enter OTP Received on Mobile
              <span class="text-danger">*</span></label>
            <input type="text" autocomplete="off" id="txtMobOTP" class="form-control" formControlName="mobotp"
              (keypress)="numberOnly($event)" placeholder="Enter OTP" minlength="6" maxlength="6" />
            <div *ngIf="f['mobotp'].touched && f['mobotp'].invalid" class="alert alert-danger">
              <div *ngIf="f['mobotp'].errors && f['mobotp'].errors['required']">
                Enter otp sent to your mobile
              </div>
              <div *ngIf="f['mobotp'].errors && f['mobotp'].errors['minLength']">
                OTP should be of length 6 digits only
              </div>
              <div *ngIf="f['mobotp'].errors && f['mobotp'].errors['maxLength']">
                OTP should be of length 6 digits only
              </div>
              <div *ngIf="f['mobotp'].errors && f['mobotp'].errors['pattern']">
                Entered Mobile OTP is incorrect. Please enter correct OTP
              </div>
            </div>
          </div>
          <div class="col-md-2 mb-2 mt-4">
            <button id="btnSave" type="button" (click)="verifyOTP()" [disabled]="isVerifyButtonDisabled"
              class="btn btn-success">
              Verify OTP
            </button>
          </div>
        </div>
        <!-- GST Number in another row -->
        <div class="row mb-3">
          <div class="col-md-3 mb-2">
            <label class="nowrap">GST Number</label>
            <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" autocomplete="off"
              formControlName="gstNumber" trimValue id="txtGSTNumber" class="form-control" name="gstNumber"
              placeholder="Enter GST Number"                 maxlength="15" />

            <div *ngIf="f['gstNumber'].touched && f['gstNumber'].invalid" class="alert alert-danger required">
              <div *ngIf="f['gstNumber'].errors?.['required']">
                GST Number is required
              </div>
              <div *ngIf="f['gstNumber'].errors?.['minlength']">
                Minimum length should be 15 characters.
              </div>
              <div *ngIf="f['gstNumber'].errors?.['pattern']" class="alert alert-danger required">
                Enter proper GST number only.
                <br />First Two Characters (2 digits): Represents the state code
                as per the Indian Census. <br />Next Ten Characters (10 digits):
                Represents the PAN (Permanent Account Number) of the business
                entity. <br />Next Character (1 digit): Represents the entity
                number of the Pan holder <br />Next Character (1 character):
                Represents the entity type:Z: Default value. <br />Last
                Character (1 digits): Represents the alphabet or number.
              </div>
            </div>
          </div>
        </div>

        <div class="card mb-3">
          <div class="card-header">
            <h2>Participant Details</h2>
          </div>
          <div class="card-body">
            <div class="row text-start">
              <div formArrayName="newParticipants">
                <div *ngFor="let record of newParticipants.controls; let i = index" [formGroupName]="i"
                  class="row text-start">
                  <ng-container *ngIf="!record.get('IsDeleted')?.value">
                    <div class="col-md-4 mb-2">
                      <label class="nowrap" for="ParticipantName{{ i }}">Participant Name:</label>
                      <input id="ParticipantName{{ i }}" (keypress)="textAndSpaceOnly($event)" autocomplete="off"
                        class="form-control" formControlName="ParticipantName" placeholder="Enter Participant Name"
                        trimValue maxlength="50" />
                      <div *ngIf="
                          record.get('ParticipantName')?.invalid &&
                          record.get('ParticipantName')?.touched
                        " class="alert alert-danger">
                        Participant name is required.
                      </div>
                      <!-- Corrected: Access 'minlength' using bracket notation -->
                      <div *ngIf="
                          record.get('ParticipantName')?.errors?.['minlength']
                        " class="alert alert-danger required">
                        Minimum length should be 3 characters
                      </div>
                    </div>

                    <!-- Participant Designation -->
                    <div class="col-md-4 mb-2">
                      <label class="nowrap" for="ParticipantDesignation{{ i }}">Participant Designation:</label>
                      <input id="ParticipantDesignation{{ i }}" (keypress)="textAndSpaceAndDotOnly($event)"
                        autocomplete="off" class="form-control" formControlName="ParticipantDesignation" trimValue
                        placeholder="Enter Participant Designation" maxlength="50" />
                      <div *ngIf="
                          record.get('ParticipantDesignation')?.invalid &&
                          record.get('ParticipantDesignation')?.touched
                        " class="alert alert-danger">
                        Participant designation is required.
                      </div>
                      <!-- Corrected: Access 'minlength' using bracket notation -->
                      <div *ngIf="
                          record.get('ParticipantDesignation')?.errors?.[
                            'minlength'
                          ]
                        " class="alert alert-danger required">
                        Minimum length should be 3 characters
                      </div>
                    </div>

                    <!-- Participant Email -->
                    <!-- <div class="col-md-4 mb-2">
                      <label class="nowrap" for="ParticipantEmail{{ i }}">Participant Email:</label>
                      <input id="ParticipantEmail{{ i }}" class="form-control" autocomplete="off"
                        formControlName="ParticipantEmail" placeholder="Enter Participant Email" trimValue
                        maxlength="100" />
                      <div *ngIf="
                          record.get('ParticipantEmail')?.invalid &&
                          record.get('ParticipantEmail')?.touched
                        " class="alert alert-danger">
                        Participant email is required.
                      </div>
                    </div> -->

                    <div class="col-md-4 mb-2">
  <label class="nowrap" for="ParticipantEmail{{ i }}">
    Participant Email:
  </label>

  <input
    id="ParticipantEmail{{ i }}"
    class="form-control"
    autocomplete="off"
    formControlName="ParticipantEmail"
    placeholder="Enter Participant Email"
    maxlength="100"
    (blur)="validateEmail(record)"
  />

  <div
    *ngIf="record.get('ParticipantEmail')?.touched && record.get('ParticipantEmail')?.invalid"
    class="alert alert-danger mt-1 p-1"
  >
    <div *ngIf="record.get('ParticipantEmail')?.errors?.['required']">
      Participant email is required.
    </div>

    <div *ngIf="record.get('ParticipantEmail')?.errors?.['email']">
      Enter a valid email address.
    </div>
  </div>
</div>

                    <!-- Participant Number -->
                    <div class="col-md-4 mb-2">
                      <label class="nowrap" for="ParticipantMobile{{ i }}">Participant Number:</label>
                      <input id="ParticipantMobile{{ i }}" (keypress)="numberOnly($event)" autocomplete="off"
                        class="form-control" formControlName="ParticipantMobile" placeholder="Enter Participant Number"
                        maxlength="10" />
                      <div *ngIf="
                          record.get('ParticipantMobile')?.invalid &&
                          record.get('ParticipantMobile')?.touched
                        " class="alert alert-danger">
                        Participant number is required.
                      </div>
                    </div>

                    <div class="col-md-4 mb-2" *ngIf="isEditMode">
                      <label class="nowrap" for="ParticipantEnrollmentId{{ i }}">Participant Enrollment ID:</label>
                      <input id="ParticipantEnrollmentId{{ i }}" type="text" autocomplete="off" class="form-control"
                        formControlName="enrollmentId" placeholder="Enrollment ID" readonly />
                    </div>

                    <!-- Remove Button -->
                    <div class="col-md-4 mb-2">
                      <button type="button" class="btn btn-danger btn-sm mt-md-4" (click)="removeNewParticipants(i)">
                        <i class="bi bi-trash"></i> Remove
                      </button>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- Add More Button -->
              <div class="col-md-4 mb-2">
                <button type="button" class="btn btn-primary text-start" (click)="addMoreParticipants()">
                  Add More
                </button>
              </div>
            </div>

            <!-- Displaying New Documents -->
            <table class="table table-striped table-bordered table-hover"></table>
          </div>
        </div>
        <div class="text-center mt-3">
          <button id="btnSave" type="button" (click)="onSubmit()" class="btn btn-success m-2" [disabled]="
              (isEditMode && !otpSuccess) ||
              newParticipants.length < 1 ||
              (!isEditMode && !otpSuccess)
            ">
            {{ isEditMode ? "Update" : "Save" }}
          </button>
          <button id="btncancel" type="reset" (click)="onReset()" class="btn btn-danger">
            Cancel
          </button>
        </div>
      </form>

      <div class="modal-backdrop" *ngIf="showPopup">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ popupTitle }}</h5>
            <button type="button" class="close-button" (click)="closePopup()">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p class="popup-message">{{ popupMessage }}</p>

            <div *ngIf="pastEventsData.length > 0">
              <h6>Past Event Details:</h6>
              <ul class="event-list">
                <li *ngFor="let event of pastEventsData">
                  <strong>Event Name:</strong> {{ event.EventName }}<br />
                  <strong>Event ID:</strong> {{ event.EventId }}<br />
                  <strong>Date:</strong>
                  {{ event.EventDate | date: "mediumDate" }}<br />
                  <strong>Intervention:</strong> {{ event.InterventionName
                  }}<br />
                  <strong>Interest:</strong> {{ event.InterestName }}<br />
                  <strong>Organization:</strong> {{ event.NameOfOrganisation }}
                </li>
              </ul>
            </div>
            <div *ngIf="pastEventsData.length === 0 && popupMessage !== ''">
              <p>No specific past event details were provided.</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closePopup()">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
        <div class="orginfodiv" *ngIf="!isOtpFlow">

  <form [formGroup]="formWithoutOtp">
    
    <div class="row">
      <div class="col-md-12 mb-5 text-center">
        <h2>On the Spot Registration (Without OTP)</h2>
        
          <h3>( UDYAM Registered MSME are allowed to enroll )</h3>
        
      </div>

   
<div class="col-md-3 mb-2">
  <label class="nowrap">
    Udyam Number <span class="text-danger">*</span>
  </label>

  <input
    type="text"
    autocomplete="off"
    formControlName="udyamNumber"
    id="txtUdyam"
    class="form-control"
    maxlength="19"
     (input)="onUdyamInput($event)"  
    placeholder="Enter Udyam Number"
    [disabled]="!isUdyamAvailable"
    [readonly]="isEditMode || isVerified"
    [ngClass]="{ 'readonly-input': isEditMode }"
  />

  <!-- Validation -->
  <div
    *ngIf="o['udyamNumber'].touched && o['udyamNumber'].invalid"
    class="alert alert-danger mt-2"
  >
    <div *ngIf="o['udyamNumber'].errors?.['required']">
      Udyam Number is required
    </div>

    <div *ngIf="o['udyamNumber'].errors?.['pattern']">
      Please enter a valid UDYAM registration number
    </div>
  </div>
</div>

      <!-- Mobile -->
      <div class="col-md-3 mb-2">
        <label>Mobile Number <span class="text-danger">*</span></label>
        <input type="text" formControlName="mobileNo" class="form-control"
          maxlength="10" (keypress)="numberOnly($event)" placeholder="Enter Mobile Number"
          [disabled]="!isUdyamAvailable"
          [readonly]="isEditMode || isVerified" />

        <!-- <div *ngIf="o['mobileNo'].touched && o['mobileNo'].invalid"
          class="alert alert-danger">
          Mobile number is required / invalid


            <div class="alert alert-warning">
                  Please enter Mobile Number Registered with your Udyam
                  Registration. OTP will be sent to it.
                </div>
        </div> -->


         <div *ngIf="o['mobileNo'].touched && o['mobileNo'].invalid">
                <div *ngIf="
                    o['mobileNo'].errors && o['mobileNo'].errors['required']
                  " class="alert alert-danger required">
                  Mobile number is required
                </div>
                <div *ngIf="
                    o['mobileNo'].errors && o['mobileNo'].errors['pattern']
                  ">
                  Mobile number should be 10 digits only, first digit should be
                  non zero
                </div>
                <div class="alert alert-warning">
                  Please enter Mobile Number Registered with your Udyam
                  Registration.
                </div>
              </div>
      </div>


      <!-- Verify -->
      <!-- <div class="col-md-1 mb-2">
        <button *ngIf="!isEditMode"
          class="btn btn-success mt-4"
          (click)="verifyUdyamwithoutOtp(o['udyamNumber'].value, o['mobileNo'].value)"
          [disabled]="!isUdyamAvailable || isVerified">
          Verify
        </button>
      </div> -->
    </div>

    <!-- Enterprise -->
    <div class="row">
      <div class="col-md-3 mb-2">
        <label>Enterprise Name <span class="text-danger">*</span></label>
        <input type="text" formControlName="enterpriseName"
          class="form-control" placeholder="Enterprise Name"
                   maxlength="20"
          [readonly]="isEditMode || isVerified" />

        <div *ngIf="o['enterpriseName'].touched && o['enterpriseName'].invalid"
          class="alert alert-danger">
          Enterprise Name is required
        </div>
      </div>

      <!-- Email -->
      <div class="col-md-3 mb-2">
        <label>Email <span class="text-danger">*</span></label>
        <input type="text" formControlName="email"
          class="form-control" placeholder="Email"
          maxlength="30"
          [readonly]="isEditMode || isVerified" />

        <div *ngIf="o['email'].touched && o['email'].invalid"
          class="alert alert-danger">
          Enter valid email
        </div>
      </div>
    </div>

    <!-- GST -->
<div class="row mb-3">
  <div class="col-md-3 mb-2">
    <label>GST Number</label>

    <input
      type="text"
      formControlName="gstNumber"
      class="form-control"
      placeholder="Enter GST Number"
                maxlength="15"
      (keypress)="numberAndCapitalAlphabetsOnly($event)"
    />

    <!-- Same Error UI -->
    <div
      *ngIf="formWithoutOtp.get('gstNumber')?.touched && formWithoutOtp.get('gstNumber')?.invalid"
      class="alert alert-danger mt-2"
    >
      <div *ngIf="formWithoutOtp.get('gstNumber')?.errors?.['minlength']">
        Minimum length should be 15 characters.
      </div>

      <div *ngIf="formWithoutOtp.get('gstNumber')?.errors?.['pattern']">
        Enter proper GST number only.<br />
        First Two Characters (2 digits): Represents the state code as per the Indian Census.<br />
        Next Ten Characters (10 digits): Represents the PAN (Permanent Account Number) of the business entity.<br />
        Next Character (1 digit): Represents the entity number of the PAN holder.<br />
        Next Character (1 character): Represents the entity type: Z (default value).<br />
        Last Character (1 digit): Represents alphabet or number.
      </div>
    </div>

  </div>
</div>
    <!-- Participants (UNCHANGED) -->
    <div class="card mb-3">
      <div class="card-header">
        <h2>Participant Details</h2>
      </div>


  <div class="card-body">

    <div formArrayName="newParticipantsWithoutOtp">

      <div *ngFor="let record of newParticipantsWithoutOtp.controls; let i = index"
           [formGroupName]="i" class="row mb-3">

        <!-- Name -->
        <div class="col-md-4">
          <label class="form-label">Participant Name:</label>
          <input class="form-control"
                 formControlName="ParticipantName"
                 placeholder="Enter Participant Name" />

          <div class="alert alert-danger mt-1 p-1"
               *ngIf="record.get('ParticipantName')?.touched && record.get('ParticipantName')?.invalid">
            Name is required
          </div>
        </div>

        <!-- Designation -->
        <div class="col-md-4">
          <label class="form-label">Participant Designation:</label>
          <input class="form-control"
                 formControlName="ParticipantDesignation"
                 placeholder="Enter Participant Designation" />

          <div class="alert alert-danger mt-1 p-1"
               *ngIf="record.get('ParticipantDesignation')?.touched && record.get('ParticipantDesignation')?.invalid">
            Designation is required
          </div>
        </div>


        <div class="col-md-4">
  <label class="form-label">Participant Email:</label>

  <input
    class="form-control"
    formControlName="ParticipantEmail"
    placeholder="Enter Participant Email"
        (blur)="validateEmail(record)"
  />

  <div
    class="alert alert-danger mt-1 p-1"
    *ngIf="record.get('ParticipantEmail')?.touched && record.get('ParticipantEmail')?.invalid"
  >
    <div *ngIf="record.get('ParticipantEmail')?.errors?.['required']">
      Email is required
    </div>

    <div *ngIf="record.get('ParticipantEmail')?.errors?.['email']">
      Enter a valid email address
    </div>
  </div>
</div>

        <!-- Mobile -->
        <div class="col-md-4 mt-2">
          <label class="form-label">Participant Number:</label>
          <input class="form-control"
                 formControlName="ParticipantMobile"
                           maxlength="10"
                             (keypress)="numberOnly($event)"
                 placeholder="Enter Participant Number" />

          <div class="alert alert-danger mt-1 p-1"
               *ngIf="record.get('ParticipantMobile')?.touched && record.get('ParticipantMobile')?.invalid">
            Valid mobile number is required
          </div>
        </div>

        <!-- Remove Button -->
        <div class="col-md-2 mt-4 d-flex align-items-end">
          <button type="button"
                  class="btn btn-danger"
                  (click)="removeNewParticipantsWithoutOtp(i)">
            <i class="bi bi-trash"></i> Remove
          </button>
        </div>

      </div>

    </div>

    <!-- Add More -->
    <button type="button"
            class="btn btn-primary mt-2"
            (click)="addMoreParticipantsWithoutOtp()">
      Add More
    </button>

  </div>


      <!-- <div class="card-body">
        <div class="row text-start">
          <div formArrayName="newParticipantsWithoutOtp">

            <div *ngFor="let record of newParticipantsWithoutOtp.controls; let i = index"
              [formGroupName]="i" class="row">

              <ng-container *ngIf="!record.get('IsDeleted')?.value">

                <div class="col-md-4 mb-2">
                  <input class="form-control"
                    formControlName="ParticipantName"
                    placeholder="Participant Name" />
                </div>

                <div class="col-md-4 mb-2">
                  <input class="form-control"
                    formControlName="ParticipantDesignation"
                    placeholder="Designation" />
                </div>

                <div class="col-md-4 mb-2">
                  <input class="form-control"
                    formControlName="ParticipantEmail"
                    placeholder="Email" />
                </div>

                <div class="col-md-4 mb-2">
                  <input class="form-control"
                    formControlName="ParticipantMobile"
                    placeholder="Mobile" />
                </div>

                <div class="col-md-4 mb-2">
                  <button type="button"
                    class="btn btn-danger btn-sm mt-md-4"
                    (click)="removeNewParticipantsWithoutOtp(i)">
                    Remove
                  </button>
                </div>

              </ng-container>
            </div>
          </div>

          <div class="col-md-4 mb-2">
            <button type="button"
              class="btn btn-primary"
              (click)="addMoreParticipantsWithoutOtp()">
              Add More
            </button>
          </div>
        </div>
      </div> -->
    </div>

    <!-- Submit -->
    <div class="text-center mt-3">
      <button type="button"
        (click)="onSubmitWithoutOtp()"
        class="btn btn-success m-2"
        [disabled]="newParticipants.length < 1">
        {{ isEditMode ? "Update" : "Save" }}
      </button>

      <button type="reset"
        (click)="onReset()"
        class="btn btn-danger">
        Cancel
      </button>
    </div>

  </form>
</div>
      <div class="modal-backdrop" *ngIf="showPopup">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ popupTitle }}</h5>
            <button type="button" class="close-button" (click)="closePopup()">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p class="popup-message">{{ popupMessage }}</p>

            <div *ngIf="pastEventsData.length > 0">
              <h6>Past Event Details:</h6>
              <ul class="event-list">
                <li *ngFor="let event of pastEventsData">
                  <strong>Event Name:</strong> {{ event.EventName }}<br />
                  <strong>Event ID:</strong> {{ event.EventId }}<br />
                  <strong>Date:</strong>
                  {{ event.EventDate | date: "mediumDate" }}<br />
                  <strong>Intervention:</strong> {{ event.InterventionName
                  }}<br />
                  <strong>Interest:</strong> {{ event.InterestName }}<br />
                  <strong>Organization:</strong> {{ event.NameOfOrganisation }}
                </li>
              </ul>
            </div>
            <div *ngIf="pastEventsData.length === 0 && popupMessage !== ''">
              <p>No specific past event details were provided.</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closePopup()">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>


  


<div
  class="modal fade"
  id="registrationTypeModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">

    <div class="modal-content">

      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title">
          Confirm Change
        </h5>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
        ></button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        Changing registration type will clear all entered data.
        Do you want to continue?
      </div>

      <!-- Footer -->
      <div class="modal-footer">

        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>

        <button
          type="button"
          class="btn btn-primary"
          (click)="confirmRegistrationTypeChange()"
          data-bs-dismiss="modal"
        >
          Yes, Continue
        </button>

      </div>

    </div>

  </div>
</div>
